// extracted by mini-css-extract-plugin
export default {"upgradeWrapper":"UpgradeRedesign_upgradeWrapper__j3qqt","upgradeContainer":"UpgradeRedesign_upgradeContainer__JqAkw"};